const config = {
  preload() {
  },
  create() {
  }
};

export default config
